/* Places the prepaid trust strip (templates in snippets/tmc-trust.liquid) under the buy buttons and above Check out. */
(() => {
  if (window.__tmcTrust) return;
  window.__tmcTrust = true;
  const clone = (id) => document.getElementById(id)?.content.firstElementChild?.cloneNode(true);

  const place = () => {
    document.querySelectorAll('.product-form__buttons').forEach((btns) => {
      const host = btns.closest('product-form') || btns;
      const next = host.nextElementSibling;
      if (next && next.classList.contains('tmc-trust')) return;
      const strip = clone('tmc-trust-pdp');
      if (strip) host.after(strip);
    });
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      const prev = ctas.previousElementSibling;
      if (prev && prev.classList.contains('tmc-trust')) return;
      const strip = clone('tmc-trust-cart');
      if (strip) ctas.before(strip);
    });
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; place(); });
  };
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();
